export default class TransferStateService {
    private static instance: TransferStateService;
    private store: { [key: string]: any } = {};

    public static getInstance(): TransferStateService {
        if (!TransferStateService.instance) {
            TransferStateService.instance = new TransferStateService();
        }
        return TransferStateService.instance;
    }

    public init(selector: string): this {
        const state: string | null = document.querySelector(selector)?.getAttribute('data-module-state') || null;
        this.store = state ? JSON.parse(state) : {};
        return this;
    }

    public get<T = any>(name: string): T;

    public get<T = any>(name: string, defaultValue: T): T;

    public get<T = any>(name: string, defaultValue?: T): T | undefined {
        return (this.store[name] !== undefined ? this.store[name] : defaultValue) as T;
    }
}
